import { CultureInfo } from '../culture-info.model';
import { CultureInfoDa } from './da';

/**
 * @ignore
 */
export const CultureInfoDaGL: CultureInfo = {
  name: 'da-GL',
  displayName: 'dansk (Grønland)',
  iso3LanguageCode: 'dan',
  iso2LanguageCode: 'da',
  ietfLanguageTag: 'da-GL',
  parent: CultureInfoDa
};
